import { render, staticRenderFns } from "./LawAuthorityRepresentativeList.vue?vue&type=template&id=7b17a4b9&"
import script from "./LawAuthorityRepresentativeList.vue?vue&type=script&lang=js&"
export * from "./LawAuthorityRepresentativeList.vue?vue&type=script&lang=js&"
import style0 from "./LawAuthorityRepresentativeList.vue?vue&type=style&index=0&id=7b17a4b9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports